import { SHIFT_LABELS, type ShipperProfileView } from '@khaddi/contracts';
import { Avatar, Badge, Button, Icon, LayoutPicker, Screen, Text, colors, formatAppBuild, formatVnd, radii, useSession, brandSurface } from '@khaddi/ui';
import { View } from 'react-native';
import { rememberActiveOrder } from '../activeOrder';
import { InfoRows } from '../components/InfoRows';
import { useShipperNav } from '../components/ShipperNav';
import { TabHeader } from '../components/TabHeader';
import { initialsOf } from '../format';
import { useProfile } from '../profile';
import { APP_BUILD } from '../version';

export const shiftsLabel = (profile: Pick<ShipperProfileView, 'shifts'>): string =>
  profile.shifts.map((shift) => `${SHIFT_LABELS[shift].label} ${SHIFT_LABELS[shift].time}`).join(', ') || '—';

export const AccountScreen = () => {
  const nav = useShipperNav('account');
  const { profile } = useProfile();
  const { signOut } = useSession();
  const logout = () => {
    rememberActiveOrder(null);
    signOut();
  };

  return (
    <Screen nav={nav} maxWidth={720}>
      <TabHeader title="Tài khoản" />
      <View style={{ paddingHorizontal: 16, gap: 12 }}>
        <View style={{ ...brandSurface, borderRadius: radii.xl, padding: 16, flexDirection: 'row', alignItems: 'center', gap: 14 }}>
          <Avatar initials={initialsOf(profile.name)} background={colors.gold} size={56} />
          <View style={{ flex: 1, gap: 2 }}>
            <Text variant="title" color={colors.text}>
              {profile.name}
            </Text>
            <Text variant="caption" color={colors.text}>
              {profile.phone}
            </Text>
            <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6, marginTop: 4 }}>
              <Icon name="star" size={16} color={colors.gold} filled />
              <Text variant="bodyStrong" color={colors.text} numeric>
                {profile.rating.toLocaleString('vi-VN', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}
              </Text>
              <Badge label={profile.online ? 'Đang nhận đơn' : 'Đang nghỉ'} tone={profile.online ? 'positive' : 'neutral'} style={{ marginLeft: 6 }} />
            </View>
          </View>
        </View>

        <InfoRows
          rows={[
            { label: 'Phương tiện', value: [profile.vehicleType, profile.vehicleModel].filter(Boolean).join(' · ') },
            { label: 'Biển số', value: profile.plate || '—' },
            { label: 'Khu vực', value: profile.areas.join(', ') || '—' },
            { label: 'Ca chạy', value: shiftsLabel(profile) },
            { label: 'COD đang giữ', value: formatVnd(profile.codHolding) },
          ]}
        />
        <Text variant="caption" style={{ paddingHorizontal: 4 }}>
          Cần đổi thông tin xe hoặc khu vực? Liên hệ quản lý quán để cập nhật hồ sơ.
        </Text>
        <LayoutPicker />
        <Button label="Đăng xuất" icon="logout" variant="outline" onPress={logout} />
        <Text variant="caption" color={colors.textSubtle} style={{ textAlign: 'center' }}>
          {formatAppBuild(APP_BUILD)}
        </Text>
      </View>
    </Screen>
  );
};
